import { appColors, BackrsIcon } from '@backrs_ui/common-ui';

import { appStrings } from '@backrs_ui/grow-ui/src/assets/appStrings';

import { Box, Typography } from '@mui/material';
import { SxProps, Theme } from '@mui/system';

const COMPETENCY_STRINGS = appStrings.modules.competency;

export const EmptyCompetencyView = () => {
  return (
    <Box sx={containerStyle}>
      <BackrsIcon name="IconComingSoon" alt={COMPETENCY_STRINGS.comingSoon} />
      <Typography variant="h5" sx={typographyStyle}>
        {COMPETENCY_STRINGS.comingSoon}
      </Typography>
    </Box>
  );
};

const containerStyle: SxProps<Theme> = {
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  justifyContent: 'center',
  height: '100%',
  width: '100%',
  margin: '0 auto',
  gap: 2,
};

const typographyStyle: SxProps<Theme> = {
  textAlign: 'center',
  fontSize: '48px',
  color: appColors.color.blue1,
  marginRight: 7,
};
